// Prazo de pagamento do fornecedor (treinamento 07/10 item 19, Rafael 10/10): fornecedor com
// "Prazo (em dias)" no cadastro recebe em hoje + prazo. Parcela lançada antes disso só gera AVISO
// (não bloqueia o salvar). Datas em 'YYYY-MM-DD'.

const doisDigitos = (n) => String(n).padStart(2, '0');
const isoLocal = (d) => `${d.getFullYear()}-${doisDigitos(d.getMonth() + 1)}-${doisDigitos(d.getDate())}`;

// { prazo, dataMinima, antes } — null quando o fornecedor não tem prazo cadastrado.
export function avaliarPrazoFornecedor(prazoDias, dataPagamento, hoje = new Date()) {
    const prazo = Number(prazoDias);
    if (!Number.isFinite(prazo) || prazo <= 0) return null;
    const base = new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate());
    base.setDate(base.getDate() + Math.round(prazo));
    const dataMinima = isoLocal(base);
    return { prazo: Math.round(prazo), dataMinima, antes: !!dataPagamento && String(dataPagamento) < dataMinima };
}
